import { z } from 'zod';
import { customFieldTypeSchema } from './custom-field';

export const customFieldValueDateSchema = z.object({
  year: z.number().int().optional(),
  month: z.number().int().optional(),
  day: z.number().int().optional(),
});

const oneofKeys = ['stringValue', 'longValue', 'doubleValue', 'boolValue', 'dateValue'] as const;

export const customFieldValuePayloadSchema = z
  .object({
    description: z.string().optional(),

    // oneof payload (0 or 1 field allowed)
    stringValue: z.string().optional(),
    longValue: z.number().int().optional(),
    doubleValue: z.number().optional(),
    boolValue: z.boolean().optional(),
    dateValue: customFieldValueDateSchema.optional(),
  })
  .superRefine((value, ctx) => {
    const setCount = oneofKeys.filter((k) => value[k] !== undefined).length;
    if (setCount > 1) {
      ctx.addIssue({
        code: 'custom',
        message:
          'FieldValuePayload oneof: at most one of stringValue/longValue/doubleValue/boolValue/dateValue allowed',
      });
    }
  });

export const customFieldValueSchema = z.object({
  id: z.number().int().positive(),
  payload: customFieldValuePayloadSchema,
});

export const customFieldValueSetSchema = z.object({
  fieldId: z.number().int().positive(),
  fieldType: customFieldTypeSchema,
  itemId: z.number().int().positive(),
  fieldValues: z.array(customFieldValueSchema),
});

export const customFieldValueListSchema = z.object({
  itemFieldValues: z.array(customFieldValueSetSchema),
});

export const customFieldValuesByItemIdSchema = z.object({
  itemId: z.number().int().positive(),
  values: z.array(customFieldValueListSchema),
});

export type CustomFieldValueDateDTO = z.infer<typeof customFieldValueDateSchema>;
export type CustomFieldValuePayloadDTO = z.infer<typeof customFieldValuePayloadSchema>;
export type CustomFieldValueDTO = z.infer<typeof customFieldValueSchema>;
export type CustomFieldValueSetDTO = z.infer<typeof customFieldValueSetSchema>;
export type CustomFieldValueListDTO = z.infer<typeof customFieldValueListSchema>;
export type CustomFieldValuesByItemIdDTO = z.infer<typeof customFieldValuesByItemIdSchema>;
